export const SETTINGS_POPOVER_PATHS = [
  {
    path: '/mis-mesas',
    label: 'Mis mesas',
  },
  {
    path: '/crear-mesa',
    label: 'Crear Mesa',
  },
  {
    path: '/faqs',
    label: 'Preguntas frecuentes',
  },
  {
    path: '/review',
    label: 'Reseñas',
  },
];
